<script>
    import { state, ui, res, prefs, live } from './stores.js';

    import { isSelected } from "./ui.js";
    import CardImage from './CardImage.svelte';

    import {crossfade, customFlip} from './crossfade.js'
    const [send, receive] = crossfade

    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css'; // optional for styling

    export let c;
    export let actions;
    export let scale;

    let cardElement;
    let actionElement;
    let tip;

    $: if(isSelected($ui, c)){
        if(!tip && cardElement){
            tip = tippy(cardElement, {
                content: actionElement,
                trigger: 'manual',
                interactive: true,
                appendTo: document.body
            })
            if(tip) tip.show();
        }
    }else{
        if(tip){
            tip.hide();
            tip.destroy();
            tip = null;
        }
    }

    function hover(e){
        //console.log('hovering', c)
        if(!c || !c.uniqueID) return;
        $live.hoveringCard = c;
        $live.hoveringFacedown = false;
        $live.shouldHideHover = false;
    }

    function unhover(e){
        if(!c || !c.uniqueID) return;
        if($live.hoveringCard == c){
            $live.shouldHideHover = {x: e.clientX, y: e.clientY};
        }
    }
    
</script>


<div bind:this={cardElement} class="outer" class:selected={isSelected($ui, c)}  
style="min-width: {$res.cardWidth * $prefs.cardScale *scale}vmin; width:{$res.cardWidth * $prefs.cardScale*scale}vmin; height: {$res.cardHeight * $prefs.cardScale*scale}vmin; --width: {$res.cardWidth * $prefs.cardScale*scale}vmin; --height: {$res.cardHeight * $prefs.cardScale*scale}vmin;">
    {#if isSelected($ui, c)}
        <div style="position: absolute; top: 0; left:0; z-index: 100000; width: {$res.cardWidth * $prefs.cardScale*scale}vmin; height: {$res.cardHeight * $prefs.cardScale*scale}vmin; border: 5px dashed orange; pointer-events: none; box-sizing: border-box;" />
    {/if}
    {#each [ c ] as c (c ? c.uniqueID: NaN)}
            
        <div style="height: 100%; position: relative;"
            in:receive|global="{{key: c ? c.uniqueID : NaN, duration: 200 }}"
            out:send|global="{{key: c ? c.uniqueID : NaN, duration: 200 }}"
            animate:customFlip
            on:mouseenter={hover}
            on:mousemove={hover}
            on:mouseleave={unhover}
        >
            <CardImage c={c} selectable />
        </div>
    {/each}
</div>

<div style="display: none;">
    <div bind:this={actionElement} class="card_action_container">
        <div class="card_actions">
            {#each actions as a}
                {#if a.show(c)}
                    <button style="margin: 5px;" on:click={e => {a.func(c)}}>
                        {a.text}
                    </button>
                {/if}
            {/each}
        </div>
    </div>
</div>

<style>
    .card_action_container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .card_actions { 
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
        padding-top: 2vmin;
        padding-bottom: 2vmin;
        z-index: 99;
        top: 0%;
        pointer-events: all;
    }

    .outer {
        position: relative;
        display: block;
        width: 15.75vmin; 
        height: 22vmin;
        touch-action: manipulation;
        user-select: none;
        margin: auto;
        box-sizing: border-box;
    }


    .selected {
        /*border: 3px dashed orange;*/
        /*margin: 0.5px;*/
        filter: saturate(3)
    }
</style>